
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class Loading extends Vue {
  /** 标记是否为首次激活，首次由 getData 内部控制 loading，后续激活时重置 */
  private isFirstActivation = true

  created() {
    this.showLoading()
  }

  /**
   * keep-alive 下 activated 每次切回都会触发。
   * 非首次激活时重置 loading，防止其他页面的 mixin created() 残留的全局 loading 影响当前页。
   */
  activated() {
    if (this.isFirstActivation) {
      this.isFirstActivation = false
      return
    }
    this.hideLoading()
  }

  showLoading() {
    this.$store.dispatch('setLoading', true)
  }
  hideLoading() {
    this.$store.dispatch('setLoading', false)
  }

  get loading() {
    return this.$store.getters.loading;
  }
}

